import { render, staticRenderFns } from "./datatableDisponibilitaAlpi.vue?vue&type=template&id=3bc1cec4"
import script from "./datatableDisponibilitaAlpi.vue?vue&type=script&lang=js"
export * from "./datatableDisponibilitaAlpi.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports